import { render, staticRenderFns } from "./DeleteRawModal.vue?vue&type=template&id=6b586c40&scoped=true"
import script from "./DeleteRawModal.vue?vue&type=script&lang=js"
export * from "./DeleteRawModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteRawModal.vue?vue&type=style&index=0&id=6b586c40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b586c40",
  null
  
)

export default component.exports